import React, { useState, useEffect } from 'react';
import { Wifi, Star, CloudDownload, CloudUpload } from 'lucide-react';
import { contactInfo } from '../mockData';
import { plansAPI } from '../services/api';

const PlansSection = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await plansAPI.getResidential();
      setPlans(response.data);
    } catch (error) {
      console.error('Error fetching plans:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="planos" className="py-16 bg-white">
        <div className="container mx-auto px-4 text-center">
          <p className="text-xl text-gray-600">Carregando planos...</p>
        </div>
      </section>
    );
  }

  return (
    <section id="planos" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
            Nossos planos mais pedidos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className="bg-white rounded-lg shadow-xl overflow-hidden border border-gray-200"
            >
              {/* Header with gradient */}
              <div className="bg-gradient-to-br from-orange-500 to-yellow-400 text-white p-6 text-center">
                <div className="text-5xl font-bold mb-1">{plan.speed}</div>
                <div className="text-xl font-bold tracking-wide">MEGA</div>
              </div>

              {/* Body */}
              <div className="p-6">
                {/* Price */}
                <div className="text-center mb-6">
                  <div className="flex items-start justify-center">
                    <span className="text-lg font-bold text-gray-800 mt-1">R$</span>
                    <span className="text-5xl font-bold text-gray-800 mx-1">
                      {plan.price.split(',')[0]}
                    </span>
                    <div className="flex flex-col items-start">
                      <span className="text-lg font-bold text-gray-800">,{plan.price.split(',')[1]}</span>
                      <span className="text-xs text-gray-600 -mt-1">/mês</span>
                    </div>
                  </div>
                </div>

                {/* Features */}
                <ul className="space-y-2 mb-6 text-sm">
                  <li className="flex items-center text-gray-700">
                    <Wifi className="text-orange-500 mr-2 flex-shrink-0" size={16} />
                    <span>Wi-fi {plan.speed >= 500 ? '6G' : '5G'} incluso</span>
                  </li>
                  <li className="flex items-center text-gray-700">
                    <Star className="text-orange-500 mr-2 flex-shrink-0" size={16} />
                    <span>Suporte Premium</span>
                  </li>
                  <li className="flex items-center text-gray-700">
                    <CloudDownload className="text-orange-500 mr-2 flex-shrink-0" size={16} />
                    <span>{plan.speed} mega de Download</span>
                  </li>
                  <li className="flex items-center text-gray-700">
                    <CloudUpload className="text-orange-500 mr-2 flex-shrink-0" size={16} />
                    <span>{Math.floor(plan.speed / 2)} mega de Upload</span>
                  </li>
                </ul>

                {/* Button */}
                <a
                  href={contactInfo.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-orange-500 to-yellow-400 text-white py-3 rounded-lg text-center font-bold hover:from-orange-600 hover:to-yellow-500 transition-all shadow-md"
                >
                  Contratar
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlansSection;
